import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefixParticipants } from '../../../constants'
import { ActionsCommon } from '../../common/ActionsCommon'

interface ActionsProps {
  selected: number
  onRemoveSelected(): void
}

export const ParticipantsActions = ({
  selected,
  onRemoveSelected,
}: ActionsProps) => {
  const tRelative = useTranslationRankmi({
    prefix: prefixParticipants,
  })
  return (
    <ActionsCommon
      label={tRelative('actions.label')}
      removeSelectedLabel={tRelative('actions.removeSelected', {
        count: selected,
      })}
      selected={selected}
      onRemoveSelected={onRemoveSelected}
    />
  )
}
